import { normalizeVideoDetailsResponse } from './adapters';
import { IVideoDetailsResponse } from '../common/types';
import { PYTHON_BACKEND } from '../constants/env';
import { ApiEndpoint, ContentType, HttpHeader, HttpMethod, HttpStatus } from '../constants/http';

export async function fetchVideoDetails(docId: string): Promise<IVideoDetailsResponse | void> {
  const baseUrl = PYTHON_BACKEND;
  const endpoint = `documents/${docId}/${ApiEndpoint.VideoDetails}`;
  const url = `${baseUrl}/${endpoint}/`;
  const requestOptions = {
    method: HttpMethod.GET,
    headers: {
      [HttpHeader.ContentType]: ContentType.JSON,
    },
  };

  try {
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    if (!response.ok) {
      if (response.status === HttpStatus.InternalServerError) {
        throw new Error('[api.fetch-video-details]: Internal Server Error');
      }
      if (data && data.message) {
        throw new Error(data.message);
      }
      throw new Error('[api.fetch-video-details]: Something went wrong!');
    }
    return normalizeVideoDetailsResponse(data);
  } catch (error: unknown) {
    console.error(error);
  }
}
